import {
    CalendarIcon,
    DiffIcon,
    InfoIcon,
    NumberIcon,
    ShareAndroidIcon
} from "@primer/octicons-react";
import {
    Box,
    Text
} from "@primer/react";
import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";

import { Table } from "@primer/react/lib-esm/DataTable";
import styled from "styled-components";
import { hocSinhApi } from "../../../../api/hocSinhApi";
import UserAvatar from "../../../../components/user-avatar";
import { IHocSinhTongHopAceItemResponse } from "../../../../models/response/hocsinh/IHocSinhTongHopAceItemResponse";
interface IHocSinhGroup {
    key: string;
    students: IHocSinhTongHopAceItemResponse[];
}
type PhuHuynhProps = {
    ts_hocsinh_id: number,
}
const StyledContainer = styled(Box)`
    padding: 12px;
  `;

const StyledTable = styled(Table)`
    width: 100%;
    border-collapse: collapse;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    border-radius: 6px;
    display: flex;
    flex-direction: column;
  `;

const StudentCard = styled.div`
    flex: 1;
    min-width: 300px;
    padding: 20px;
    border: 1px solid #d0d7de;
    border-radius: 8px;
    background-color: white;
    display: flex;
    flex-direction: column;
    gap: 16px;
    cursor: pointer;
    transition: all 0.2s ease;
    &:hover {
      border-color: #0366d6;
      box-shadow: 0 4px 12px rgba(0,0,0,0.1);
      transform: translateY(-2px);
    }
  `;
const PhuHuynh = (props: PhuHuynhProps) => {
    const [allHocSinhs, setAllHocSinhs] = useState<any[]>([]);
    const loadAllHocSinh = useCallback(async () => {
        const res = await hocSinhApi.SelectTongHopPhuHuynh(props.ts_hocsinh_id);
        if (res.is_success) {
            setAllHocSinhs(res.data);
        }
    }, [,]);
    useEffect(() => {
        loadAllHocSinh();
    }, [props.ts_hocsinh_id]);
    return (
        <StyledContainer>
            <StyledTable>
                <Box sx={{
                    height: 'calc(100vh - 350px)',
                    overflowY: 'auto',
                }}>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell style={{ padding: '5px' }} colSpan={6}>
                                <Box sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 3,
                                    padding: '12px'
                                }}>
                                    {allHocSinhs.map((student) => (
                                        <StudentCard
                                            key={student.id}
                                        >
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 2,
                                                mb: 0
                                            }}>
                                                <UserAvatar fullName={student.ho_ten} size="large" />
                                                <Box sx={{ flex: 1 }}>
                                                    <Text sx={{ fontWeight: 600, color: '#0969da', fontSize: 2 }}>
                                                        {student.ho_ten}
                                                    </Text>
                                                </Box>
                                            </Box>
                                            <Box sx={{
                                                background: '#f6f8fa',
                                                p: 2,
                                                mt: 0,
                                                borderRadius: '6px',
                                                fontSize: '13px'
                                            }}>

                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Box sx={{ color: '#0969da' }}><CalendarIcon size={14} /></Box>
                                                    Ngày sinh: <Text sx={{ fontWeight: 600 }}>
                                                        {student.ngay_sinh_ph ? moment(student.ngay_sinh_ph).format('DD/MM/YYYY') : ''}
                                                    </Text>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
                                                    <Box sx={{ color: '#0969da' }}><NumberIcon size={14} /></Box>
                                                    Điện thoại: <Text sx={{ fontWeight: 600 }}>{student.dien_thoai}</Text>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
                                                    <Box sx={{ color: '#0969da' }}><ShareAndroidIcon size={14} /></Box>
                                                    Email: <Text sx={{ fontWeight: 600 }}>{student.email}</Text>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
                                                    <Box sx={{ color: '#0969da' }}><InfoIcon size={14} /></Box>
                                                    Cơ quan công tác: <Text sx={{ fontWeight: 600 }}>{student.noi_lam_viec}</Text>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
                                                    <Box sx={{ color: '#0969da' }}><DiffIcon size={14} /></Box>
                                                    Miễn giảm: <Text sx={{ fontWeight: 600 }}>{student.noi_lam_viec}</Text>
                                                </Box>
                                            </Box>
                                        </StudentCard>
                                    ))}
                                </Box>
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Box>
            </StyledTable>
        </StyledContainer>
    );
};

export default PhuHuynh;